import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import NewKaryawan from "../../components/NewKaryawan";
import Grid from '@mui/material/Grid';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import React, {Component} from 'react';
import axios from "axios";
import { useEffect, useState, useRef } from 'react';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import NumberFormat from 'react-number-format';
import InputAdornment from '@mui/material/InputAdornment';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import AddIcon from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PhoneInput from 'react-phone-number-input';
import CheckIcon from "@mui/icons-material/Check";
import "./style.css";
import {useNavigate} from "react-router-dom";
import { useLocation} from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import BusinessIcon from '@mui/icons-material/Business';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import PersonIcon from '@mui/icons-material/Person';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from 'react-redux';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
  },
});
export default function EditCompany({useData,penelpon,mencari,noTelpPenelpon,tujuan,setTujuan,setNoTelpPenelpon,setMencari,setPenelpon, searchThis, setTanggalKejadian, simpanCall, tanggalKejadian}){
    const [openCallCenterDashboard,setOpenCallCenterDashboard]= useState()
    const nowstate = useSelector(state => state);

    const anotherCallForwardPotential = () => {
        setOpenCallCenterDashboard(true)
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/newPotentialPulsaUser`, {
            useData, user:nowstate.user
        }).then(() => {
        }).catch(error => {
            // handle error
            console.log(error);
        }); 
    }
    return <Grid xs={12} container sx={{p:1}}>
    <Dialog open={openCallCenterDashboard} onClose={()=>setOpenCallCenterDashboard(false)} maxWidth={"xl"}>
    <DialogContent>
    <Grid xs={12} container sx={{p:1}}>
    <ThemeProvider theme={darkTheme}>

                <Grid xs={9} container>
                <Paper elevation={3} sx={{ padding: 2, margin: 2 }}>  {/* Add Paper here */}
                    <Grid xs={12} container>
                                        {
                                            searchThis === "Klien"
                                    ? (<Grid container>
                                            <Grid item xs={2.5}>
                                                <PersonIcon sx={{ width: 100, height: 100 }} />
                                            </Grid>
                                            <Grid item xs={9.5}>
                                                <Grid container>
                                                    <Grid item xs={4}>Nama Klien</Grid>
                                                    <Grid item xs={0.5}>:</Grid>
                                                    <Grid item xs={7.5}>{useData.klien.Nama}</Grid>
                                                </Grid>

                                                <Grid container>
                                                    <Grid item xs={4}>Notes</Grid>
                                                    <Grid item xs={0.5}>:</Grid>
                                                    <Grid item xs={7.5}>{useData.klien.notes ?? "Tidak ada"}</Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>)
                                    : (
                                        <Grid container>
                                            <Grid item xs={2.5}>
                                                <BusinessIcon sx={{ width: 100, height: 100 }} />
                                            </Grid>
                                            <Grid item xs={9.5}>
                                                <Grid container>
                                                    <Grid item xs={4}>Nama Perusahaan</Grid>
                                                    <Grid item xs={0.5}>:</Grid>
                                                    <Grid item xs={7.5}>{useData.company.namaPerusahaan ?? "Tidak ada"}</Grid>
                                                </Grid>

                                                <Grid container>
                                                    <Grid item xs={4}>Industri</Grid>
                                                    <Grid item xs={0.5}>:</Grid>
                                                    <Grid item xs={7.5}>{useData.company.industri ?? "Tidak ada"}</Grid>
                                                </Grid>

                                                <Grid container>
                                                    <Grid item xs={4}>Notes</Grid>
                                                    <Grid item xs={0.5}>:</Grid>
                                                    <Grid item xs={7.5}>{useData.company.notes ?? "Tidak ada"}</Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )
                                }

                            <Grid item xs={12}>
                                <Divider variant="middle" sx={{ mt: 5, mb: 5 }} />
                            </Grid>
                            <Grid container>
                                        <Grid xs={4}>Private Office</Grid>
                                        <Grid xs={0.5}>:</Grid>
                                        <Grid xs={7.5} sx={{mt:1.3}}>
                                        <p style={{ fontFamily: 'Open Sans, sans-serif', fontSize: 'small' }}>
                                            {useData.kontrak.some(kontrak => kontrak.TipeKontrak === 'Private Office')
                                                ? useData.kontrak
                                                    .filter(kontrak => kontrak.TipeKontrak === 'Private Office')
                                                    .map((kontrak, index) => {
                                                        return (
                                                        <span key={index}>
                                                            {kontrak?.lokasiSingkatan
                                                            ? `${kontrak.selectedRooms}(` 
                                                            : kontrak.selectedRooms
                                                            }
                                                            {kontrak?.lokasiSingkatan && 
                                                            <b>{kontrak.lokasiSingkatan})</b>
                                                            }
                                                        </span>
                                                        );
                                                    })
                                                : 'Tidak ada'}
                                            </p>
                                        </Grid>
                                    </Grid>
                                    <Grid container sx={{mt:5}}>
                                    Call Handling Detail
                                    <TableContainer component={Paper} sx={{ width: '100%',mt:5 }}>
                                        <Table sx={{ minWidth: 650, width: '100%' }} aria-label="simple table">
                                            <TableHead>
                                            <TableRow>
                                                <TableCell>Nama</TableCell>
                                                <TableCell>Posisi</TableCell>
                                                <TableCell>Case</TableCell>
                                                <TableCell>Method</TableCell>
                                                <TableCell>Nomor</TableCell>
                                            </TableRow>
                                            </TableHead>
                                    <TableBody >   
                                    {Array.isArray(useData.callCenter) && useData.callCenter.map((center, centerIndex) => (
    Array.isArray(center.listHandling) && center.listHandling.map((handling, handlingIndex) => (
        <TableRow key={`center-${centerIndex}-handling-${handlingIndex}`}>
            <TableCell>{handling.Nama}</TableCell>
            <TableCell>{handling.Posisi}</TableCell>
            <TableCell>{handling.Case}</TableCell>
            <TableCell>{handling.Method}</TableCell>
            <TableCell>{handling.Nomor}</TableCell>
        </TableRow>
    ))
))}

                                    </TableBody>
                                    </Table>
</TableContainer>
                                    </Grid>
                            <Grid item xs={12}>
                                <Divider variant="middle" sx={{ mt: 5, mb: 5 }} />
                            </Grid>
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                        {
                                            searchThis === "Klien"
                                    ? (
                                        <TableContainer sx={{ maxHeight: 300, minHeight: 250 }} className="min-h-screen h-screen overflow-scroll">
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>
                                                            Nama Perusahaan
                                                        </TableCell>
                                                        <TableCell>
                                                            Posisi
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {useData.klien.Companies?.map((post) => (
                                                    <TableBody>
                                                        <TableRow key={`${post.id}`}
                                                                hover
                                                                >
                                                            <TableCell>
                                                                <p>{post.NamaPT??""}</p>
                                                            </TableCell>
                                                            <TableCell>
                                                            <p>{post.posisi??""}</p>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                
                                                ))}

                                            </Table>
                                        </TableContainer>

                                    )
                                    :(
                                        <TableContainer sx={{ maxHeight: 300, minHeight: 250 }} className="min-h-screen h-screen overflow-scroll">
                                            <Table stickyHeader aria-label="sticky table">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>
                                                            Nama Karyawan
                                                        </TableCell>
                                                        <TableCell>
                                                            Posisi
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                {useData.klienList?.map((post) => (
                                                    <TableBody>
                                                        <TableRow key={`${post.id}`}
                                                                hover
                                                                >
                                                            <TableCell style={{cursor:'pointer'}}>
                                                                <p>{post.Nama}</p>
                                                            </TableCell>
                                                            <TableCell style={{cursor:'pointer'}}>
                                                                <p>
                                                                {
                                                                    post.Companies?.find(
                                                                        company => company.CompanyID === useData.kontrak?.CompanyID
                                                                    )?.posisi ?? ""
                                                                }
                                                                </p>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                
                                                ))}

                                            </Table>
                                        </TableContainer>
                                        )}
                            </Paper>
                    </Grid>
                    </Paper>
                    </Grid>
                    </ThemeProvider>
                <Grid container xs={3}>
                <Paper elevation={3} sx={{ padding: 2, margin: 2 }}>  {/* Add Paper here */}
                        <Grid>Penelpon:</Grid>
                        <TextField value={penelpon} onChange={(event)=>setPenelpon(event.target.value)}></TextField>
                        <Grid>Mencari:</Grid>
                        <TextField value={mencari} onChange={(event)=>setMencari(event.target.value)}></TextField>
                        <Grid>No. Telp:</Grid>
                        <TextField value={noTelpPenelpon} onChange={(event)=>setNoTelpPenelpon(event.target.value)}></TextField>
                        <Grid>Tujuan:</Grid>
                        <TextareaAutosize value={tujuan} onChange={(event)=>setTujuan(event.target.value)} style={{ minHeight:"200px", width: "100%" }}></TextareaAutosize>
                        </Paper>
                </Grid>
        </Grid>
        </DialogContent>
        <DialogActions>
                    <Grid style={{ marginRight: 'auto' }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}  style={{ marginRight: 'auto' }}>

                    <MobileDatePicker 
                        views={['year', 'month', 'day']}
                        inputFormat="dd/MM/yyyy"
                        value={tanggalKejadian}
                        onChange={(event)=>setTanggalKejadian(event)}
                        renderInput={(params) => 
                            <TextField 
                                {...params} 
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment >
                                            <CalendarMonthIcon />
                                        </InputAdornment>
                                    ),
                                    style: { height: '35px'}
                                }}
                            />
                        }
                    />

                    </LocalizationProvider>
                    </Grid>
                    <Button variant="contained" color="success" onClick={simpanCall}>
                    <Typography>Simpan dan Notifikasi</Typography>
                    </Button>
                    </DialogActions>
    </Dialog>
    
    <Grid xs={9} container>
    <Paper elevation={3} sx={{ padding: 2, margin: 2 }}>  {/* Add Paper here */}
        <Grid xs={12} container>
                            {
                                searchThis === "Klien"
                        ? (<Grid container>
                                <Grid item xs={2.5}>
                                    <PersonIcon sx={{ width: 100, height: 100 }} />
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Grid container>
                                        <Grid item xs={4}>Nama Klien</Grid>
                                        <Grid item xs={0.5}>:</Grid>
                                        <Grid item xs={7.5}>{useData.klien.Nama}</Grid>
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={4}>Notes</Grid>
                                        <Grid item xs={0.5}>:</Grid>
                                        <Grid item xs={7.5}>{useData.klien.notes ?? "Tidak ada"}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>)
                        : (
                            <Grid container>
                                <Grid item xs={2.5}>
                                    <BusinessIcon sx={{ width: 100, height: 100 }} />
                                </Grid>
                                <Grid item xs={9.5}>
                                    <Grid container>
                                        <Grid item xs={4}>Nama Perusahaan</Grid>
                                        <Grid item xs={0.5}>:</Grid>
                                        <Grid item xs={7.5}>{useData.company.namaPerusahaan}</Grid>
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={4}>Industri</Grid>
                                        <Grid item xs={0.5}>:</Grid>
                                        <Grid item xs={7.5}>{useData.company.industri}</Grid>
                                    </Grid>

                                    <Grid container>
                                        <Grid item xs={4}>Notes</Grid>
                                        <Grid item xs={0.5}>:</Grid>
                                        <Grid item xs={7.5}>{useData.company.notes ?? "Tidak ada"}</Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )
                    }

                <Grid item xs={12}>
                    <Divider variant="middle" sx={{ mt: 5, mb: 5 }} />
                </Grid>
                <Grid container>
                            <Grid xs={4}>Private Office</Grid>
                            <Grid xs={0.5}>:</Grid>
                            <Grid xs={7.5} sx={{mt:1.3}}>
                            <p style={{ fontFamily: 'Open Sans, sans-serif', fontSize: 'small' }}>
                                {useData.kontrak.some(kontrak => kontrak.TipeKontrak === 'Private Office')
                                    ? useData.kontrak
                                        .filter(kontrak => kontrak.TipeKontrak === 'Private Office')
                                        .map((kontrak, index) => {
                                            return (
                                            <span key={index}>
                                                {kontrak?.lokasiSingkatan
                                                ? `${kontrak.selectedRooms}(` 
                                                : kontrak.selectedRooms
                                                }
                                                {kontrak?.lokasiSingkatan && 
                                                <b>{kontrak.lokasiSingkatan})</b>
                                                }
                                            </span>
                                            );
                                        })
                                    : 'Tidak ada'}
                                </p>
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid xs={4}>Call Center</Grid>
                            <Grid xs={0.5}>:</Grid>
                            <Grid xs={7.5} sx={{mt:1.3}}>
                            <p style={{ fontFamily: 'Open Sans, sans-serif', fontSize: 'small' }}>
                                {useData.callCenter==="None"
                                    ? 'Tidak ada'
                                    : <Button variant="contained" color="success" onClick={()=>anotherCallForwardPotential()}>Dashboard Call Center</Button>}
                                </p>
                            </Grid>
                        </Grid>
                <Grid item xs={12}>
                    <Divider variant="middle" sx={{ mt: 5, mb: 5 }} />
                </Grid>
                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            {
                                searchThis === "Klien"
                        ? (
                            <TableContainer sx={{ maxHeight: 300, minHeight: 250 }} className="min-h-screen h-screen overflow-scroll">
                                  <Table stickyHeader aria-label="sticky table">
                                      <TableHead>
                                          <TableRow>
                                              <TableCell>
                                                  Nama Perusahaan
                                              </TableCell>
                                              <TableCell>
                                                  Posisi
                                              </TableCell>
                                          </TableRow>
                                      </TableHead>
                                      {useData.klien.Companies?.map((post) => (
                                          <TableBody>
                                              <TableRow key={`${post.id}`}
                                                    hover
                                                    >
                                                  <TableCell>
                                                      <p>{post.NamaPT??""}</p>
                                                  </TableCell>
                                                  <TableCell>
                                                  <p>{post.posisi??""}</p>
                                                  </TableCell>
                                              </TableRow>
                                          </TableBody>
                                      
                                      ))}

                                  </Table>
                              </TableContainer>

                        )
                        :(
                              <TableContainer sx={{ maxHeight: 300, minHeight: 250 }} className="min-h-screen h-screen overflow-scroll">
                                  <Table stickyHeader aria-label="sticky table">
                                      <TableHead>
                                          <TableRow>
                                              <TableCell>
                                                  Nama Karyawan
                                              </TableCell>
                                              <TableCell>
                                                  Posisi
                                              </TableCell>
                                          </TableRow>
                                      </TableHead>
                                      {useData.klienList?.map((post) => (
                                          <TableBody>
                                              <TableRow key={`${post.id}`}
                                                    hover
                                                    >
                                                  <TableCell style={{cursor:'pointer'}}>
                                                      <p>{post.Nama}</p>
                                                  </TableCell>
                                                  <TableCell style={{cursor:'pointer'}}>
                                                      <p>
                                                      {
                                                        post.Companies?.find(
                                                            company => company.CompanyID === useData.kontrak?.CompanyID
                                                        )?.posisi ?? ""
                                                    }
                                                      </p>
                                                  </TableCell>
                                              </TableRow>
                                          </TableBody>
                                      
                                      ))}

                                  </Table>
                              </TableContainer>
                              )}
                </Paper>
         </Grid>
        </Paper>
        </Grid>
    <Grid container xs={3}>
    <Paper elevation={3} sx={{ padding: 2, margin: 2 }}>  {/* Add Paper here */}
            <Grid>Penelpon:</Grid>
            <TextField value={penelpon} onChange={(event)=>setPenelpon(event.target.value)}></TextField>
            <Grid>Mencari:</Grid>
            <TextField value={mencari} onChange={(event)=>setMencari(event.target.value)}></TextField>
            <Grid>No. Telp:</Grid>
            <TextField value={noTelpPenelpon} onChange={(event)=>setNoTelpPenelpon(event.target.value)}></TextField>
            <Grid>Tujuan:</Grid>
            <TextareaAutosize value={tujuan} onChange={(event)=>setTujuan(event.target.value)} style={{ minHeight:"200px", width: "100%" }}></TextareaAutosize>
            </Paper>
    </Grid>

       
</Grid>
}